import { Button, Dialog, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../../muiTheme";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";

interface CancelModalProps {
  open: boolean;
  handleClose: () => void;
  onAccept: () => void;
  environment: string;
}

const ManagementsContractEndModal: React.FC<CancelModalProps> = ({
  open,
  handleClose,
  onAccept,
  environment,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose} className="eBills-dialog">
      <Stack gap={"1.5rem"} paddingBottom={{ xs: "1rem", md: "2.5rem" }}>
        <Stack direction={"row"} padding={0} justifyContent="space-between">
          <Typography variant="h2" component="p">
            {t(
              "Gestiones.¿Confirma que quiere que enviemos la baja por cese de actividad a la distribuidora?",
            )}
          </Typography>
          <Button onClick={handleClose} sx={{ alignSelf: "start" }}>
            <Typography fontSize="32px" color={theme.palette.grey[900]}>
              <span className="t-icon-close"></span>
            </Typography>
          </Button>
        </Stack>
        <Typography variant="subtitle1" component="p">
          {t(
            `Gestiones.Le recordamos que en caso de realizarse su suministro quedaría sin ${environment.toLowerCase()}`,
          )}
        </Typography>
      </Stack>
      <Stack gap={"1rem"}>
        <ButtonElement onClick={onAccept}>
          {t("Gestiones.Sí, continuar")}
        </ButtonElement>
        <ButtonElement secondary onClick={handleClose}>
          {t("Botón volver")}
        </ButtonElement>
      </Stack>
    </Dialog>
  );
};

export default ManagementsContractEndModal;
